import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { Image as ImageType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'

import { Img } from './Image.styled'

export const isSvg = (image: ImageType): boolean => {
    return image.localFile.extension === 'svg'
}

export const isGif = (image: ImageType): boolean => {
    return image.localFile.extension === 'gif'
}

export const Image = ({
    image,
    className,
    width,
    height,
    loading = 'lazy',
    imageAnimation,
}: {
    image: ImageType
    className?: string
    width?: number
    height?: number
    loading?: 'eager' | 'lazy'
    imageAnimation?: boolean
}): Nullable<JSX.Element> => {
    if (!image.localFile) {
        return null
    }

    const Wrapper = imageAnimation ? Tilt : React.Fragment

    if (isSvg(image) || isGif(image)) {
        return (
            <Wrapper>
                <Img
                    src={image.localFile.publicURL}
                    alt={image?.alternativeText}
                    className={className}
                    width={width}
                    height={height}
                />
            </Wrapper>
        )
    }

    const img = getImage(image.localFile)

    if (img) {
        return (
            <Wrapper>
                <GatsbyImage
                    image={img}
                    title={image?.alternativeText}
                    alt={image?.alternativeText}
                    className={className}
                    loading={loading}
                />
            </Wrapper>
        )
    }

    return null
}
